// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA7weLi-yqC95aLefgeptGF4w6joWsNzds",
  authDomain: "elevate-5a47e.firebaseapp.com",
  projectId: "elevate-5a47e",
  storageBucket: "elevate-5a47e.firebasestorage.app",
  messagingSenderId: "596923159537",
  appId: "1:596923159537:web:14f104c90e9fe9cb5d2a50",
  measurementId: "G-0TMZ6NZ5B3"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
